import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import * as RequestTypes from "../DataTypes/requestTypes";
import * as Fetch from "../../Common/fetch";
import * as Actions from "./actions";
import * as ProviderTypes from "../DataTypes/providerTypes";
import * as Notifications from "../../Common/Notifications/helper";
import { Step } from "../DataTypes/storeTypes";
import { flushSteps } from "./actions";

export function selectProvider(id: number, dependentSteps?: Step[]) {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(flushAvailability());
        dispatch(flushSteps([Step.Group]));
        dispatch(selectProviderInternal(id));

        if (dependentSteps) {
            dispatch(Actions.flushSteps(dependentSteps));
        }

        dispatch(Actions.moveNext());
    };
}

export function selectProviderInternal(id: number): ActionGenerics.IParamAction<ActionTypes.Actions, number> {
    return { type: ActionTypes.Actions.SelectProvider, parameter: id };
}

export function getProviders(dispatch, state: StoreTypes.IStore) {
    const request: RequestTypes.IAppointmentRequest = {
        locationId: state.stepsInfo[StoreTypes.Step.Location].id,
        serviceId: state.stepsInfo[StoreTypes.Step.Service].id,
        type: StoreTypes.BookingType[state.initialSettings.type],
    };

    return Fetch.post<ProviderTypes.IProvider[]>(state.initialSettings.getProvidersUrl, request)
        .then((data) => dispatch(updateProviders(data)))
        .catch((data) => Notifications.error(data.message));
}

function updateProviders(
    providers: ProviderTypes.IProvider[]
): ActionGenerics.IParamAction<ActionTypes.Actions, ProviderTypes.IProvider[]> {
    return { type: ActionTypes.Actions.UpdateProviders, parameter: providers };
}

function flushAvailability() {
    return { type: ActionTypes.Actions.FlushAvailability };
}
